import React, { useEffect, useRef } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { theme } from '../../styles/theme';
import Header from './Header';
import Footer from './Footer';
import Loader from '../Loader/Loader';
import { useLoader } from '../../context/LoaderContext';
import { useLocation } from 'react-router-dom';

const Main = styled.main`
  min-height: 100vh;
  background-color: ${props => props.theme.colors.cream};
`;

const Content = styled.div`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding-top: 60px;
`;

const Layout = ({ children }) => {
  const { isLoading, startLoading, stopLoading } = useLoader();
  const location = useLocation();
  const loadTimeoutRef = useRef(null);

  useEffect(() => {
    // Nettoie le timeout précédent si il existe
    if (loadTimeoutRef.current) {
      clearTimeout(loadTimeoutRef.current);
    }

    // Démarre le loader
    startLoading();

    // Configure le nouveau timeout
    loadTimeoutRef.current = setTimeout(() => {
      stopLoading();
    }, 300);

    // Nettoie le timeout au démontage ou au changement de route
    return () => {
      if (loadTimeoutRef.current) {
        clearTimeout(loadTimeoutRef.current);
      }
    };
  }, [location.pathname]);

  return (
    <ThemeProvider theme={theme}>
      <Loader isLoading={isLoading} />
      <Main>
        <Header />
        <Content>{children}</Content>
        <Footer />
      </Main>
    </ThemeProvider>
  );
};

export default Layout;
